import styled from 'styled-components/macro'
import {
  blueGradientDownward,
  commonModalContentStyle,
  darkGlassCard,
  gradientModalStyle,
  gradientModalHeaderStyle,
  gradientModalScrollbarStyle,
} from 'src/global/helpers'

export const Modal = styled.div`
  ${props => gradientModalStyle(blueGradientDownward, props.theme.blue, 'translateY(-50%) translate(0, 12vh) scale(0.01)')}
  width: 580px;
`

export const Header = styled.div`
  ${gradientModalHeaderStyle}
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  ${gradientModalScrollbarStyle}
  padding: 0 24px 100px;
`

export const Section = styled.section`
  margin-bottom: 28px;
  padding: 0 4px;

  &.intro {
    padding: 0 4px 4px;
  }

  &.intro p {
    font-size: 15px;
    margin: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  h3 {
    margin: 8px 0 12px;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.3;
    text-align: left;
  }

  p {
    margin: 0 0 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
    text-align: left;
  }

  p:last-child {
    margin-bottom: 0;
  }

  .plans {
    display: flex;
    gap: 12px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .plan {
    ${darkGlassCard}
    flex: 1;
    padding: 20px 24px;
  }

  .plan-duration {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.85);
  }

  .plan-price {
    margin-top: 2px;
    font-size: 22px;
    font-weight: 800;
    color: #ffffff;
  }

  .plan-equivalent {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
  }
`

export const Benefit = styled.div<{ $accent: string; $accentDark: string }>`
  ${darkGlassCard}
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  /* The feature's own colour, on a disc with a glow in the same colour */
  .icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: linear-gradient(145deg, ${props => props.$accent}, ${props => props.$accentDark});
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.35),
      0 6px 14px ${props => props.$accentDark}66;
    font-size: 18px;
    color: #ffffff;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
  }

  .benefit-title {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.25;
  }

  .benefit-description {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.82);
    line-height: 1.45;
  }
`

export const Footer = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  z-index: 2;

  button {
    width: 100%;
    backdrop-filter: blur(8px) brightness(1.15);
    -webkit-backdrop-filter: blur(8px) brightness(1.15);
    text-shadow: 0 1px 4.5px rgba(0, 0, 0, 0.25);
    font-size: 16px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }
`
